import { render, staticRenderFns } from "./DialogMobile.vue?vue&type=template&id=5a223eac&"
import script from "./DialogMobile.vue?vue&type=script&lang=ts&"
export * from "./DialogMobile.vue?vue&type=script&lang=ts&"
import style0 from "./DialogMobile.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogMobile.vue"
export default component.exports